<template>
  <b-form @submit.prevent="guardar">
    <b-form-row>
      <b-col cols="12">
        <b-form-group>
          <label for="reactividad">
            Reactividad <span style="color: red">(*)</span>
          </label>
          <b-form-textarea id="reactividad"
                           name="reactividad"
                           required
                           data-vv-as=" "
                           v-model="selectedSeccion10.reactividad"
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion10.reactividad')"
          />
        </b-form-group>
        <b-form-group>
          <label for="estabilidad">
            Estabilidad <span style="color: red">(*)</span>
          </label>
          <b-form-textarea id="estabilidad"
                        name="estabilidad"
                        required
                        data-vv-as=" "
                        v-model="selectedSeccion10.estabilidad"
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion10.estabilidad')"
          />
        </b-form-group>
        <b-form-group>
          <label for="posibilidad_reacciones_peligrosas">
            Posibilidad de reacciones peligrosas <span style="color: red">(*)</span>
          </label>
          <b-form-textarea id="posibilidad_reacciones_peligrosas"
                           name="posibilidad_reacciones_peligrosas"
                           required
                           data-vv-as=" "
                           v-model="selectedSeccion10.posibilidad_reacciones_peligrosas"
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion10.posibilidad_reacciones_peligrosas')"
          />
        </b-form-group>
        <b-form-group>
          <label for="condiciones_evitar">
            Condiciones a evitar <span style="color: red">(*)</span>
          </label>
          <b-form-textarea id="condiciones_evitar"
                           name="condiciones_evitar"
                           required
                           data-vv-as=" "
                           v-model="selectedSeccion10.condiciones_evitar"
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion10.condiciones_evitar')"
          />
        </b-form-group>
        <b-form-group>
          <label for="incompatibilidad">
            Incompatibilidad <span style="color: red">(*)</span>
          </label>
          <b-form-textarea id="incompatibilidad"
                           name="incompatibilidad"
                           required
                           data-vv-as=" "
                           v-model="selectedSeccion10.incompatibilidad"
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion10.incompatibilidad')"
          />
        </b-form-group>
        <b-form-group>
          <label for="riesgos_polimerizacion">
            Riesgos de polimerización <span style="color: red">(*)</span>
          </label>
          <b-form-textarea id="riesgos_polimerizacion"
                           name="riesgos_polimerizacion"
                           data-vv-as=" "
                           v-model="selectedSeccion10.riesgos_polimerizacion"
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion10.riesgos_polimerizacion')"
          />
        </b-form-group>
        <b-form-group>
          <label for="productos_desc_peligrosos">
            Productos de descomposición peligrosos <span style="color: red">(*)</span>
          </label>
          <b-form-textarea id="productos_desc_peligrosos"
                           name="productos_desc_peligrosos"
                           data-vv-as=" "
                           v-model="selectedSeccion10.productos_desc_peligrosos"
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion10.productos_desc_peligrosos')"
          />
        </b-form-group>
      </b-col>
    </b-form-row>

    <hr>
    <FooterButtons back="/fds/listar" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';

export default {
  name: "FDS-Seccion10",
  components: {
    FooterButtons
  },
  data() {
    return {
    }
  },
  async created() {
    await this.setSeccionActual(10);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
    } else {
      await this.resetSeccion();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar'){
        await this.actualizarSeccion();
      }
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion'
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'resetSeccion',
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion10'
    ])
  }
}
</script>
